import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NzModalService } from 'ng-zorro-antd/modal';
import { SignOutService } from './sign-out';

/**
 * The `/logout` route. It renders nothing: signing out is a question, and the
 * answer is either the Entra sign-out redirect or going back where you came
 * from.
 *
 * Rexine has always asked before signing out — a misplaced click in the avatar
 * menu otherwise costs a full redirect round trip and a fresh sign-in — and
 * every vertical asks the same question now.
 */
@Component({
  selector: 'kf-logout',
  template: '',
})
export class LogoutComponent implements OnInit {
  private readonly modal = inject(NzModalService);
  private readonly router = inject(Router);
  private readonly signOutService = inject(SignOutService);

  ngOnInit(): void {
    this.modal.confirm({
      nzTitle: 'Confirm',
      nzContent: 'Are you sure to logout?',
      nzOnOk: () => this.signOutService.signOut(),
      nzOnCancel: () => this.router.navigate(['/']),
    });
  }
}
